<script>
    import { Route, Router } from 'yrv'
    import PaymentsPurchases from './payments-purchases.svelte'
    import PaymentsGateways from '../account/payments-gateways/payments-gateways.svelte'
    import PaymentsLink from './payments-link.svelte'
    import PaymentsCharges from './payments-charges.svelte'
    import PaymentsRefunds from './payments-refunds.svelte'
    import PaymentsSubscription from './payments-subscription.svelte'
    import Ztab from '../_common/z/ztab.svelte'

    let tabs = []
    tabs.push({ title: 'ZanduPay', url: '/payments/purchases' })
    tabs.push({ title: 'Parcelas', url: '/payments/charges' })
    tabs.push({ title: 'Estornos', url: '/payments/refunds' })
    tabs.push({ title: 'Cobranças', url: '/payments/links' })
    tabs.push({ title: 'Assinaturas', url: '/payments/subscriptions' })
</script>

<div class="root-content">
    <Ztab class="h-space h-print" {tabs} />
    <Router>
        <Route path="/purchases">
            <PaymentsPurchases />
        </Route>
        <Route path="/charges">
            <PaymentsCharges />
        </Route>
        <Route path="/refunds">
            <PaymentsRefunds />
        </Route>
        <Route path="/subscriptions">
            <PaymentsSubscription />
        </Route>
        <Route path="/links">
            <PaymentsLink />
        </Route>
    </Router>
</div>
